import { render, staticRenderFns } from "./reisen.vue?vue&type=template&id=d235107e"
import script from "./reisen.vue?vue&type=script&lang=js"
export * from "./reisen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports